class BlogPostsList extends HTMLElement {
  connectedCallback() {
    const grid = this.querySelector('[ref="grid"]');
    const button = this.querySelector('[ref="loadMoreButton"]');
    const wrapper = this.querySelector('[ref="loadMoreWrapper"]');

    if (!grid || !button) return;

    const loadMoreCount = parseInt(grid.dataset.loadMoreCount || '6', 10);

    button.addEventListener('click', () => {
      const hidden = grid.querySelectorAll('.blog-post-item--hidden');
      let revealed = 0;

      for (const card of hidden) {
        if (revealed >= loadMoreCount) break;
        card.classList.remove('blog-post-item--hidden');
        revealed++;
      }

      const remaining = grid.querySelectorAll('.blog-post-item--hidden');

      if (remaining.length === 0 && wrapper) {
        wrapper.style.display = 'none';
      }
    });
  }
}

if (!customElements.get('blog-posts-list')) {
  customElements.define('blog-posts-list', BlogPostsList);
}
